import React from 'react';

import Helmet from 'react-helmet';

import NotFound from './NotFound'; // 404 page
import Page500 from './Page500'; // 500 page
import Header from './Header';

const ErrorPage = ({ errorStatus, className }) => (
    <div>
        <Helmet>
            <link
                href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;800;900&display=swap"
                rel="stylesheet"
            />
        </Helmet>
        <Header />
        {errorStatus === 500 ? (
            <Page500 errorStatus={errorStatus} className={className} />
        ) : (
            <NotFound errorStatus={errorStatus} className={className} />
        )}
    </div>
);

export default ErrorPage;
